import { useState, useRef, useEffect } from "react";
import { P, FF } from "../../styles/tokens";
import { fmt, sum } from "../../utils/format";
import { isFijoVencido, isFijoPorVencer } from "../../utils/gastos";
import InputRow from "./InputRow";
import ExtrasInputRow from "./ExtrasInputRow";
import FijosInputRow from "./FijosInputRow";
import { useToast } from "../../contexts/ToastContext";

export default function EditSection({ title, icon, token, rows, field, setMonth, onSaveItem, showCat, isFijos, cuentas, computedSaldos, activeMonth, year }) {
  // Cerrada por default si tiene items, abierta si está vacía
  const [open, setOpen] = useState(rows.length === 0);
  const t = token;
  const toast = useToast();
  const endRef = useRef(null);
  const [justAdded, setJustAdded] = useState(false);

  // Auto-scroll al nuevo item después de agregar
  useEffect(() => {
    if (justAdded && endRef.current) {
      endRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      setJustAdded(false);
    }
  }, [justAdded, rows.length]);

  const update = (id, r) => {
    setMonth(prev => ({
      ...prev,
      [field]: prev[field].map((x) => (x.id === id ? r : x)),
    }));
    onSaveItem?.(r);
    toast.show("✓ Guardado");
  };

  const remove = (id) => setMonth(prev => ({
    ...prev,
    [field]: prev[field].filter((x) => x.id !== id),
  }));

  const add = () => {
    let newRow;
    const todayStr = new Date().toISOString().slice(0, 10);
    if (isFijos) newRow = { id: crypto.randomUUID(), concepto: "", monto: 0, cat: "", fechaLimite: "", pagado: false, montoPagado: null };
    else if (showCat) newRow = { id: crypto.randomUUID(), concepto: "", monto: 0, cat: "", msi: null, fecha: todayStr };
    else newRow = { id: crypto.randomUUID(), concepto: "", monto: 0, fecha: todayStr };
    setMonth(prev => ({
      ...prev,
      [field]: [...prev[field], newRow],
    }));
    // Abrir sección si estaba cerrada + auto-scroll
    if (!open) setOpen(true);
    setJustAdded(true);
  };

  const realRows = rows.filter(r => !String(r.id).startsWith("rec_") || r.pagado);
  const itemCount = realRows.length;

  return (
    <div style={{ marginBottom: 14, borderRadius: 16, border: `1.5px solid ${P.border}`, overflow: "hidden", background: P.surface }}>
      {/* Header con botón [+] integrado */}
      <div style={{
        display: "flex", alignItems: "center", background: t.pastel,
        borderBottom: open ? `1.5px solid ${t.tint}` : "none",
      }}>
        <button
          type="button"
          onClick={() => setOpen(!open)}
          style={{
            flex: 1, padding: "14px 20px", display: "flex", justifyContent: "space-between", alignItems: "center",
            border: "none", cursor: "pointer", fontFamily: FF, background: "transparent",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ fontSize: 16 }}>{icon}</span>
            <span style={{ fontWeight: 700, fontSize: 14, color: t.text }}>{title}</span>
            {/* Badge de conteo */}
            <span style={{ fontSize: 10, fontWeight: 700, background: t.tint, color: t.text, borderRadius: 99, padding: "1px 7px", minWidth: 18, textAlign: "center" }}>
              {itemCount}
            </span>
            {isFijos && (() => {
              const venc = rows.filter((r) => isFijoVencido(r, activeMonth, year)).length;
              const prox = rows.filter((r) => isFijoPorVencer(r, activeMonth, year)).length;
              return (venc > 0 || prox > 0) ? (
                <span style={{
                  fontSize: 10, fontWeight: 700,
                  background: venc > 0 ? P.danger.pastel : P.warn.pastel,
                  color: venc > 0 ? P.danger.text : P.warn.text,
                  borderRadius: 99, padding: "2px 7px",
                  border: `1px solid ${venc > 0 ? P.danger.tint : P.warn.tint}`,
                }}>
                  {venc > 0 ? `⚠${venc}` : `⏰${prox}`}
                </span>
              ) : null;
            })()}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ fontWeight: 800, fontSize: 15, color: t.text, fontFamily: FF }}>{fmt(sum(rows))}</span>
            <span style={{ color: t.mid, fontSize: 11 }}>{open ? "▲" : "▼"}</span>
          </div>
        </button>
        {/* Botón [+] siempre visible en el header */}
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); add(); }}
          style={{
            width: 44, height: 44, marginRight: 8, borderRadius: 12,
            border: `1.5px solid ${t.tint}`, background: P.surface,
            color: t.text, fontSize: 18, fontWeight: 700,
            cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
            flexShrink: 0,
          }}
        >
          +
        </button>
      </div>
      {open && (
        <div style={{ padding: "4px 20px 16px" }}>
          {isFijos
            ? rows.map((row) => <FijosInputRow key={row.id} row={row} onChange={(r) => update(row.id, r)} onDelete={() => remove(row.id)} cuentas={cuentas} computedSaldos={computedSaldos} />)
            : showCat
              ? rows.map((row) => <ExtrasInputRow key={row.id} row={row} onChange={(r) => update(row.id, r)} onDelete={() => remove(row.id)} cuentas={cuentas} />)
              : rows.map((row) => <InputRow key={row.id} row={row} onChange={(r) => update(row.id, r)} onDelete={() => remove(row.id)} cuentas={cuentas} />)
          }
          <div ref={endRef} />
        </div>
      )}
    </div>
  );
}
